import { initialize } from '@frontegg/js';

class Login {
    constructor() {
        this.clientId = window.klarnachrichtenConfig?.fronteggClientId;
        this.appUrl = window.klarnachrichtenConfig?.fronteggAppUrl;
        if (!this.clientId || !this.appUrl) return;

        this.loginSpinner  = document.getElementById('login-spinner');
        this.loginBtn      = document.getElementById('login-btn');
        this.loginAvatar   = document.getElementById('login-avatar');
        this.loginInitials = document.getElementById('login-initials');
        this.loginDropdown = document.getElementById('login-dropdown');
        this.loginUsername = document.getElementById('login-username');
        this.loginLogout   = document.getElementById('login-logout');
        this.loginManageSub = document.getElementById('login-manage-subscription');

        this.initFrontegg();
    }

    initFrontegg() {
        const locale = window.klarnachrichtenConfig?.locale || 'de';
        const app = initialize({
            contextOptions: { baseUrl: this.appUrl, clientId: this.clientId },
            hostedLoginBox: true,
            authOptions: {
                keepSessionAlive: true,
                hostedLoginOptions: {
                    loadUserOnFirstLoad: true,
                    customLoginOptions: { language: locale },
                },
            },
            entitlementsOptions: {
                enabled: false,
            },
        });
        this.app = app;

        const checkState = () => {
            const { isAuthenticated, user, isLoading } = app.store.getState().auth;
            if (!isLoading) this.updateUI(isAuthenticated, user);
        };

        app.store.subscribe(checkState);
        checkState();

        this.loginBtn?.addEventListener('click', () =>
            app.loginWithRedirect({ language: window.klarnachrichtenConfig?.locale || 'de' }));

        this.loginAvatar?.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleDropdown();
        });

        this.loginLogout?.addEventListener('click', () =>
            app.logout({ post_logout_redirect_uri: window.location.origin }));

        this.loginManageSub?.addEventListener('click', () => {
            window.klarnachrichten.openSubscriptionOverlay();
            this.closeDropdown();
        });

        document.addEventListener('click', () => this.closeDropdown());
    }

    updateUI(isAuthenticated, user) {
        this.loginSpinner?.classList.add('hidden');
        if (isAuthenticated && user) {
            this.loginBtn?.classList.add('hidden');
            this.loginBtn?.classList.remove('flex');
            this.loginAvatar?.classList.remove('hidden');
            this.loginAvatar?.classList.add('flex');
            if (this.loginInitials)
                this.loginInitials.textContent = this.getInitials(user.name || user.email);
            if (this.loginUsername)
                this.loginUsername.textContent = user.name || user.email;
            // Show subscription link for authenticated users
            this.loginManageSub?.classList.remove('hidden');
        } else {
            this.loginAvatar?.classList.add('hidden');
            this.loginAvatar?.classList.remove('flex');
            this.loginBtn?.classList.remove('hidden');
            this.loginBtn?.classList.add('flex');
            this.loginManageSub?.classList.add('hidden');
            this.closeDropdown();
        }
    }

    getInitials(name) {
        const parts = name.trim().split(/\s+/);
        return parts.length >= 2
            ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
            : name.slice(0, 2).toUpperCase();
    }

    toggleDropdown() {
        this.loginDropdown?.classList.contains('hidden')
            ? this.openDropdown() : this.closeDropdown();
    }

    openDropdown() {
        this.loginDropdown?.classList.remove('hidden');
        this.loginAvatar?.setAttribute('aria-expanded', 'true');
    }

    closeDropdown() {
        this.loginDropdown?.classList.add('hidden');
        this.loginAvatar?.setAttribute('aria-expanded', 'false');
    }
}

window.klarnachrichten.login = new Login();
